<template>
    <span>
        <b-card no-body>
        <b-card-header>
            <b-row>
                 <b-col md="9">
                    <h3> Visualizar Feedback</h3>
                 </b-col>
                 <b-col md="3">
                    <p><b>Nome:</b> {{usuarioLogado.nome}}</p>
                    <p><b>Perfil:</b> {{usuarioLogado.perfil}}</p>
                    <p><b>Estado:</b> {{usuarioLogado.estado}}</p>
                    <p><b>Município:</b> {{usuarioLogado.municipio}}</p>
                 </b-col>
            </b-row>
        </b-card-header>
        <b-card-body>
             <b-form v-on:submit.prevent="onSubmit">
            <b-row>
              <b-col cols="12">
                <b-form-group label="Tipo: *">
                  <b-input-group>
                    <b-form-select :disabled="true" v-model="$v.form.tipo.$model" :state="chkState('tipo')">
                      <option v-for="item in listaTipo" :key="item.id" :value="item.id"> {{item.nome}}</option>
                      <option selected :value="null"> Selecione</option>
                    </b-form-select>
                    <b-form-invalid-feedback id="input1LiveFeedback6">Tipo é obrigatório.</b-form-invalid-feedback>
                  </b-input-group>
                </b-form-group>
              </b-col>
            </b-row>
            <div cols="12">
                <label>Descreva:</label>
               <b-form-textarea
               :disabled="true"
              value="Hello, World!"
              v-model="$v.form.texto.$model"
              placeholder="Escreva a descrição aqui..."
              rows="3"
              max-rows="6"
            ></b-form-textarea>
                <b-form-invalid-feedback :state="chkState('texto')">O campo descrição é obrigatório.</b-form-invalid-feedback>
            </div>
            <div cols="12" v-if="$v.form.resposta.$model">
                <label>Resposta:</label>
               <b-form-textarea
               :disabled="true"
              value="Hello, World!"
              v-model="$v.form.resposta.$model"
              placeholder="Escreva a descrição aqui..."
              rows="3"
              max-rows="6"
            ></b-form-textarea>
                <b-form-invalid-feedback :state="chkState('resposta')">O campo resposta é obrigatório.</b-form-invalid-feedback>
            </div>
          </b-form>
        </b-card-body>
         <b-card-footer class="p-12">
          <b-row>
            <b-col offset-md="3" md="6">
              <b-button block variant="secondary" @click="$router.go(-1)">
                <i class="fa fa-mail-reply-all"></i>&nbsp;&nbsp;<span>Voltar</span>
              </b-button>
            </b-col>
          </b-row>
        </b-card-footer>
    </b-card>
    </span>
</template>

<script>
import 'v-markdown-editor/dist/v-markdown-editor.css'
import Vue from 'vue'
import AuthTemplate from '@/templates/auth/AuthTemplate'
import VueSelect from 'vue-select'
import {validationMixin} from 'vuelidate'
import {required} from 'vuelidate/lib/validators'
import miniToastr from 'mini-toastr'
import Editor from 'v-markdown-editor'
import CKEditor from 'ckeditor4-vue'
import SessionStorage from '@/services/session-storage'

miniToastr.init()
Vue.use(Editor)
Vue.use(CKEditor)

const formShape = {
  tipo: null,
  texto: '',
  reposta: ''
}

export default {
  name: 'Cadastro',
  components: {
    AuthTemplate,
    VueSelect,
    Editor
  },
  mixins: [validationMixin],
  validations: {
    form: {
      tipo: {
        required
      },
      texto: {
        required
      },
      resposta: {
        required
      }
    }
  },
  created () {
    this.$store.dispatch('getUsuario', SessionStorage.get('usuario'))
  },
  data () {
    return {
      form: Object.assign({}, formShape),
      id: 0,
      editorConfig: {
        removePlugins: 'elementspath,resize'
      },
      usuarioLogado: {
        municipio: '',
        estado: '',
        perfil: '',
        nome: ''
      },
      listaTipo: [
        {id: 1, nome: 'Dúvida'},
        {id: 2, nome: 'Elogio'},
        {id: 3, nome: 'Reclamação'},
        {id: 4, nome: 'Depoimento'}
      ]
    }
  },
  watch: {
    'usuario.perfil': function () {
      this.usuarioLogado.perfil = this.usuario.perfil.nome
      this.usuarioLogado.nome = this.usuario.nome
    },
    'usuario.dados_pessoais': function () {
      this.municipiosprogramas.forEach(element => {
        if (element.municipio_id === this.usuario.dados_pessoais.municipio_atuacao_id) {
          this.usuarioLogado.estado = element.estado.estado
          this.usuarioLogado.municipio = element.cidade.cidade
        }
      })
    }
  },
  mounted () {
    if (typeof this.$route.params.id !== 'undefined') {
      this.loadPrograma(this.$route.params.id)
    }
  },
  computed: {
    isValid () {
      return !this.$v.form.$anyError
    },
    usuario () {
      return this.$store.state.usuario.usuarioEditar
    },
    municipiosprogramas () {
      return this.$store.state.municipiosprogramas.listaMunicipiosProgramas
    }
  },
  methods: {
    salvar () {
      let form = this.$v.form

      let data = {
        id: this.id,
        tipo_feedback: form.tipo.$model,
        texto: form.texto.$model
      }

      Vue.http.post('api/feedbacks', data).then(response => {
        if (response.body.success) {
          miniToastr.setIcon('success', 'i', {'class': 'fa fa-check'})
          if (this.cadastroInterno) {
            miniToastr.success('Feedback salvo com sucesso!', 'Sucesso!', 7000)
          } else {
            miniToastr.success(response.body.msg, 'Sucesso!', 7000)
          }

          this.$router.push({path: '/feedbacks'})
        } else {
          this.disable_buttons = false
          miniToastr.setIcon('error', 'i', {'class': 'fa fa-warning'})
          miniToastr.error(response.body.msg, 'Alerta', 5000)
        }
      }).catch(e => {
        console.log('Servidor está fora! ' + e)
      })
    },
    loadPrograma (id) {
      Vue.http.get('api/feedbacks/' + id).then(response => {
        this.form.tipo = response.body.data[0].tipo_feedback
        this.form.texto = response.body.data[0].texto
        this.form.resposta = response.body.data[0].resposta
        this.id = response.body.data[0].id
      })
    },
    confirmar () {
      this.$bvModal.msgBoxConfirm('Tem certeza que deseja continuar?', {
        okTitle: 'Confirmar',
        cancelTitle: 'Cancelar'
      }).then(valor => {
        if (valor) {
          this.salvar()
        }
      }).catch(erro => {
        console.log(erro)
      })
    },
    onSubmit () {
      if (this.validate()) {
        this.confirmar()
      }
    },
    chkState (val) {
      const field = this.$v.form[val]
      return !field.$dirty || !field.$invalid
    },
    findFirstError (component = this) {
      if (component.state === false) {
        if (component.$refs.input) {
          component.$refs.input.focus()
          return true
        }
        if (component.$refs.check) {
          component.$refs.check.focus()
          return true
        }
      }
      let focused = false
      component.$children.some((child) => {
        focused = this.findFirstError(child)
        return focused
      })

      return focused
    },
    validate () {
      this.$v.$touch()
      this.$nextTick(() => this.findFirstError())
      return this.isValid
    },
    navigate (route) {
      this.$router.push(route)
    }
  }
}
</script>

<style scoped>
    #modal {
      font-style: italic;
      font-weight: bold;
      margin-top: -10px;
    }
</style>



// WEBPACK FOOTER //
// src/pages/site/interna/administrador/feedback/feedbackVisual.vue